import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateIntegrityMonitorEvents = document.createElement('template');

templateIntegrityMonitorEvents.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <header class='page__header'>
    <gz-title id='page-title' fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
  </header>
  <div class='wrapper'>
    <div class="company-selector-action">
        <gz-company-filter class="company-selector"></gz-company-filter>
    </div>

    <gz-grid-view class='grid-view'>
      <div class="header-buttons" slot="grid-header-actions-slot">
        <gz-select id="changeCategorySelect" overlayPositionX="left">
          <gz-button id="actionsButton">
            <div class="category-button-content">
              <span id="changeCategoryText"></span>
              <span class="action-icon ds-icon-dropdown_arrow"></span>
            </div>
          </gz-button>
        </gz-select>
      </div>
    </gz-grid-view>
    <gz-side-menu class='integrity-monitor-events-details-menu'></gz-side-menu>
  </div>
`;
